import React, { useRef, useState } from "react";
import Image from "mui-image";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { EmptyDetailCard } from "../core/EmptyDetailCard";
import { useDebounceCallback, useResizeObserver } from "usehooks-ts";
import { PdfViewer } from "../core/PdfViewer";
import { assetPath } from "../endpoints";
import LinkOff from "@mui/icons-material/LinkOff";

const TryPdf = ["unknown", "application/pdf", undefined, ""];

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").Sellsheet|import("@seabrookstudios/pitch2table-core").Rules|import("@seabrookstudios/pitch2table-core").GameAsset|null|undefined} props.document
 */
export const ImageOrPdfViewer = ({ document }) => {
  const [loaded, setLoaded] = useState(false);
  const [hideImage, setHideImage] = useState(false);

  const ref = useRef(null);
  const [{ width, height }, setSize] = useState({
    width: 0,
    height: 0,
  });

  const onResize = useDebounceCallback(setSize, 200);

  useResizeObserver({
    ref,
    // @ts-expect-error
    onResize,
  });

  if (!document) {
    return <EmptyDetailCard text="Select entry from list on left." />;
  }

  const useableWidth = width - 48;

  return (
    <Box p={2} pt={2} ref={ref} justifyContent="center">
      <Box>
        {!hideImage && (
          <Box display="flex" justifyContent="center">
            {!loaded && <CircularProgress />}
            {document.mimeType !== "application/pdf" && (
              <Image
                alt={""}
                onLoad={() => setLoaded(true)}
                src={assetPath(document.s3location)}
                fit="contain"
                width={useableWidth}
                errorIcon={<LinkOff />}
              />
            )}
          </Box>
        )}
      </Box>
      {TryPdf.includes(document.mimeType) && (
        <PdfViewer
          path={assetPath(document.s3location)}
          width={width}
          height={height}
          notifyOthers={() => setHideImage(true)}
        />
      )}
    </Box>
  );
};
